import { connect } from 'react-redux';
import _ from 'lodash';
import { fetchEmergencyDetails } from '../../../actions/emergencyPersonnelActions';
import { emergencyDetailsSelector } from '../../../selectors/emergencyPersonnel';
import RightArea from './RightArea';

const mapStateToProps = state => {
  return {
    assignedOfficeId: _.get(state.global.get('heroProfile'), 'assignedOfficeId', null),
    emergencyDetails: emergencyDetailsSelector(state),
  };
};

const mapDispatchProps = dispatch => {
  return {
    fetchEmergencyDetails: officeId => dispatch(fetchEmergencyDetails(officeId)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(RightArea);
